

const sidebar = {


sidebar: document.getElementById('left-sidebar') as HTMLElement, 
thumbWrapper: document.getElementById('jsThumbWrapper') as HTMLElement, 
prodWrapper: document.getElementById('jsProdsWrap') as HTMLElement, 
filterBtn:  document.getElementById('jsFilterBtn') as HTMLElement ,
results: document.getElementById('jsResults') as HTMLElement, 
resultsWrap: document.getElementById('jsResultsWrap') as HTMLElement,
show: document.getElementById('jsShowFilters') as HTMLElement, 
hide: document.getElementById('jsHideFilters') as HTMLElement, 
filterCount: document.querySelectorAll('.jsFilterCount') as NodeListOf<HTMLElement>,
filterCountWrap: document.getElementById('jsFilterCount') as HTMLElement, 

    init() {
        this.toggleSidebar();
        this.setResults();
        this.setFilterCount();
    },

    

    toggleSidebar() {
        if(this.filterBtn) {
        this.filterBtn.addEventListener('click', () => {
            this.sidebar.classList.toggle('activeClass');
            this.thumbWrapper.classList.toggle('activeClass');
            this.prodWrapper.classList.toggle('activeClass');
            this.show.classList.toggle('activeClass');
            this.hide.classList.toggle('activeClass');

        })
        }

    },

    setResults() {
        if(this.resultsWrap) {
        this.resultsWrap.innerHTML += this.results.innerHTML;
        }
        
    },

    setFilterCount() {
        if(this.filterCount.length > 0) {
        this.filterCountWrap.innerHTML += ' ' + `(` + this.filterCount.length + ')';

        }
        

    }



}

export default sidebar;


